<template>
  <div :style="cssVar">
    <div class="single-data-chart">
      <e-chart :option="singleOption" autoresize />
    </div>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FractionDisposalBarChart',
  props: {
    fractionDisposals: {
      type: Object,
      required: true,
    },
  },
  mixins: [stringUtils],
  computed: {
    cssVar() {
      return {
        // 26px bar height + 12px space = 38px in total
        '--chart-height': `${3 * 38}px`,
      }
    },
    singleOption() {
      const series = [
        {
          name: this.$t('reporting.industry.fractionDisposals.clean'),
          value: this.fractionDisposals.clean,
          itemStyle: { color: 'green' },
        },
        {
          name: this.$t('reporting.industry.fractionDisposals.mixed'),
          value: this.fractionDisposals.mixed,
          itemStyle: { color: 'yellow' },
        },
        {
          name: this.$t('reporting.industry.fractionDisposals.wrong'),
          value: this.fractionDisposals.wrong,
          itemStyle: { color: 'red' },
        },
      ]

      return this.barGraphOptions(
        series.map(entry => entry.name),
        series,
      )
    },
  },
  methods: {
    barGraphOptions(yAxisData, seriesData, axisLabel) {
      return {
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          inverse: true, // Display longer bars at top
          type: 'category',
          data: yAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            margin: 24,
            fontWeight: '700',
            fontSize: 16,
            fontFamily: 'Source Sans Pro',
            color: '#314053',
            width: 120,
            ...axisLabel,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: '215px', // 205px so the longest label text "Completely wrong Fraction" isn't cut off
          right: 0,
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            barWidth: 26,
            backgroundStyle: {
              borderRadius: 4,
              color: '#a1a1a1',
            },
            barCategoryGap: 12,
            itemStyle: {
              borderRadius: 4,
              color: '#314053',
            },
            label: {
              show: true,
              position: ['60px', '6px'],
              color: 'black',
              fontWeight: 700,
              fontSize: 16,
              fontFamily: 'Source Sans Pro',
              align: 'right',
            },
            showBackground: true,
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.single-data-chart {
  height: var(--chart-height);
}

.total-data-chart {
  height: 2rem;
  margin-bottom: 1.5rem;
}
</style>
